import React, { Fragment } from "react";
import { getFieldPath } from "utils/form";
import Toggle from "../common/Toggle";
import Prefill from "../common/Prefill";
import Connect from "../common/Connect";
import { STATE_KEYS } from "utils/constants/state";

const SettingsFields = ({ name }) => (
  <Fragment>
    <div className="pt3">
      <Toggle
        label="Hidden"
        name={getFieldPath(name, STATE_KEYS.FIELD.HIDDEN)}
        description="Hide field from view."
      />
    </div>
    <div className="pt3 mt3 bt hairline-1">
      <Prefill name={name} />
    </div>
    <div className="pt3 mt3 bt hairline-1">
      <Connect name={name} />
    </div>
  </Fragment>
);

export default SettingsFields;
